import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function deactivateUser(request) {
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  const apiPath = `/disableUser`
  return userInstance.put(apiPath, request)
}
